import { createContext, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";

// Live counts for hub sub-tabs and sidebar sub-links, keyed `<hub>.<child>` (see nav.js + backend nav.py). Polled every 60 s.
const Ctx = createContext({});

export function NavCountsProvider({ enabled, children }) {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    if (!enabled) return undefined;
    const load = () => api.get("/nav/counts").then((r) => setCounts(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    const onVis = () => { if (document.visibilityState === "visible") load(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVis); };
  }, [enabled]);
  return <Ctx.Provider value={counts}>{children}</Ctx.Provider>;
}

export const useNavCounts = () => useContext(Ctx);

export const countFor = (counts, hubKey, child) => { const n = counts[child.count || `${hubKey}.${child.key}`]; return n > 0 ? n : null; };

// Badge is its own link when a drill-in target exists: opens the list already filtered to what the count means.
export function CountBadge({ n, tone = "muted", className = "", testid, to, hint, onClick }) {
  if (!n) return null;
  const label = n > 99 ? "99+" : n;
  if (!to) return <span className={`nav-count nav-count-${tone} ${className}`} data-testid={testid} title={hint ? `${n} ${hint}` : undefined}>{label}</span>;
  return <Link to={to} onClick={onClick} className={`nav-count-hit ${className}`} data-testid={testid} title={`${n} ${hint || ""} · open filtered`.trim()} aria-label={`${n} ${hint || ""} — open filtered list`}><span className={`nav-count nav-count-link nav-count-${tone}`}>{label}</span></Link>;
}

export const drillFor = (hubKey, child) => child.drill || child.to;
